import { renewalSubscriptionModalActionTypes } from './Constants';

export function toggleRenewalSubscriptionModal(data) {
	return {
		type: renewalSubscriptionModalActionTypes.TOGGLE_RENEWAL_SUBSCRIPTION_MODAL,
		payload: {
			data,
		},
	};
}
export function getRenewalSubscription(data) {
	return {
		type: renewalSubscriptionModalActionTypes.GET_RENEWAL_SUBSCRIPTION,
		payload: data,
	};
}
export function getRenewalSubscriptionSuccess(data) {
	return {
		type: renewalSubscriptionModalActionTypes.GET_RENEWAL_SUBSCRIPTION_SUCCESS,
		payload: {
			data,
		},
	};
}
export function getRenewalSubscriptionError(error) {
	return {
		type: renewalSubscriptionModalActionTypes.GET_RENEWAL_SUBSCRIPTION_ERROR,
		payload: {
			error,
		},
	};
}
export function clearRenewalSubscriptionModalState() {
	return {
		type: renewalSubscriptionModalActionTypes.CLEAR_RENEWAL_SUBSCRIPTION_MODAL_STATE,
	};
}
